import "./clients.scss";

const Clients = () => {
    return (
        <div className="client">
             <div data-aos="fade-up" className="last">
                <p className="titlec">Some of Our Clients</p>
                <div className="inner"></div>
            </div>
        </div>
    )
}

export default Clients;